import statusLabel from './statusLabel'

const payments = {
  statusLabel,
}

export default payments
